<template>
  <div>
    <Row class="search-con">
      <Col>
        <Button @click="backHistory" class="search-btn">返回</Button>
      </Col>
    </Row>
    <Card class="info-detail">
      <h3>订单详情</h3>
      <Row>
        <Col><br /></Col>
        <Col span="6"
          ><b>订单编号:</b>
          <label style="font-size: 16px"> {{ orderInfo.order_no }}</label></Col
        >
        <Col span="6"
          ><b>客户:</b>
          <label style="font-size: 16px">
            {{ orderInfo.customerName }}</label
          ></Col
        >
        <Col span="6"
          ><b>门店:</b>
          <label style="font-size: 16px">
            {{ orderInfo.factoryName }}</label
          ></Col
        >
      </Row>
      <Row>
        <Col><br /></Col>
      </Row>
      <Row>
        <Col span="6"
          ><b>负责人:</b>
          <label style="font-size: 16px"> {{ orderInfo.salesName }}</label></Col
        >
        <Col span="6"
          ><b>总缸数:</b>
          <label style="font-size: 16px"> {{ orderInfo.all_batch }}</label></Col
        >
        <Col span="6"
          ><b>总匹数:</b>
          <label style="font-size: 16px"> {{ orderInfo.all_piece }}</label></Col
        >
      </Row>
    </Card>
    <Card>
      <Row class="search-con">
        <Col span="20">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="searchValue"
          />
          <label class="search-label">状态</label>
          <Select
            style="width: 100px"
            v-model="status"
            class="search-input"
            clearable
          >
            <Option
              v-for="item in statusList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <!-- <label class="search-label">开始时间</label>
          <Date-picker
            :value="startTime"
            @on-change="startTime = $event"
            type="datetime"
            placeholder="选择开始时间"
            style="width: 170px"
          ></Date-picker>
          <label class="search-label">结束时间</label>
          <Date-picker
            :value="endTime"
            @on-change="endTime = $event"
            type="datetime"
            placeholder="选择结束时间"
            style="width: 170px"
          ></Date-picker> -->
          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
      </Row>
      <Row class="search-con">
        <Col class="search-right">
          <Button @click="downloadReport" type="primary" class="search-btn"
            >下载整缸验布报告</Button
          >
          <!-- <Button
            @click="downloadShipment('shipment')"
            type="primary"
            class="search-btn"
            >导出出货单</Button
          >
          <Button
            @click="downloadShipment('settlement')"
            type="primary"
            class="search-btn"
            >导出结算单</Button
          > -->
          <Button @click="showAddModal" type="primary" class="search-btn"
            >添加</Button
          >
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
        @on-selection-change="changeId"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="addModal"
      title="添加染缸"
      footer-hide
    >
      <forms
        :resetFlag="resetFlag"
        ref="addChild"
        @on-ok="addSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="editModal"
      title="编辑染缸"
      footer-hide
    >
      <forms
        :resetFlag="resetFlag"
        ref="editChild"
        :editData="editData"
        @on-ok="editSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal v-model="payModal" title="修改付款状态">
      <Row>
        <Col v-if="hiddenPaySwitch">
          <p>{{ payMsg }}</p>
        </Col>
        <Col v-else>
          <i-switch v-model="payStatus" @on-change="changePayStatus"></i-switch>
          <label style="margin-left: 5px">{{ payLabel }}</label>
        </Col>
      </Row>
    </Modal>
    <Modal v-model="payTypeModal" title="修改付款方式">
      <Row>
        <Col>
          <i-switch v-model="payType" @on-change="changePayType"></i-switch>
          <label style="margin-left: 5px">{{ payTypeLabel }}</label>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./batch-form.vue";
import TablesEdit from "_c/tables/edit.vue";
import {
  getBatchList,
  getBatchInfo,
  addBatch,
  delBatch,
  editBatch,
  getOrderInfo,
  editBatchMoney,
  downloadQr,
  editPayStatus,
  editPayType,
  downloadBatchReport,
  downloadBatchShipment,
} from "@/api/data";
export default {
  name: "batch",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      modalWidth: 600,
      addModal: false,
      editModal: false,
      resetFlag: false,
      payModal: false,
      payMsg: "",
      payStatus: "",
      payLabel: "",
      hiddenPaySwitch: false,
      payTypeModal: false,
      payType: "",
      payTypeLabel: "",
      batchId: "",
      editData: {},
      searchValue: "",
      orderId: 0,
      orderInfo: {},
      edittingCellId: "",
      edittingText: "",
      startTime: "",
      endTime: "",
      selectId: [],
      pieceCount: 0,
      statusList: [
        { id: 0, name: "初创建" },
        { id: 1, name: "入库中" },
        { id: 2, name: "检测中" },
        { id: 3, name: "检测完成" },
        { id: 4, name: "检测完成" },
        { id: 5, name: "付款完成" },
        { id: 6, name: "已完成" },
      ],
      status: "",
      tableLoading: true,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        { title: "缸号", key: "batch_no", editable: true },
        { title: "客户订单号", key: "customer_order", editable: true },
        { title: "布料颜色", key: "cloth_color", width: 100, editable: true },
        { title: "品名", key: "cloth_type", width: 100, editable: true },
        { title: "匹数", key: "piece_count", width: 100, editable: true },
        { title: "总要求码长", key: "allStandLength", width: 100, editable: true },
        { title: "总测量码长", key: "allLength", width: 100, editable: true },
        {
          title: "金额",
          key: "money",
          width: 150,
          // render: (h, params) => {
          //   return h(TablesEdit, {
          //     props: {
          //       params: params,
          //       value: this.tableData[params.index][params.column.key],
          //       edittingCellId: this.edittingCellId,
          //       editable: true,
          //     },
          //     on: {
          //       input: (val) => {
          //         this.edittingText = val;
          //       },
          //       "on-start-edit": (params) => {
          //         this.edittingCellId = `editting-${params.index}-${params.column.key}`;
          //         this.$emit("on-start-edit", params);
          //       },
          //       "on-cancel-edit": (params) => {
          //         this.edittingCellId = "";
          //         this.$emit("on-cancel-edit", params);
          //       },
          //       "on-save-edit": (params) => {
          //         this.value = this.edittingText;
          //         this.changeBatchMoney(params, this.value);
          //         this.edittingCellId = "";
          //       },
          //     },
          //   });
          // },
          editable: true,
        },
        { title: "总重量(kg)", key: "all_weight", width: 120, editable: true },
        {
          title: "状态",
          key: "status",
          width: 100,
          render: (h, params) => {
            let texts = "";
            if (params.row.status == 0) {
              texts = "初创建";
            } else if (params.row.status == 1) {
              texts = "入库中";
            } else if (params.row.status == 2) {
              texts = "检测中";
            } else if (params.row.status == 3) {
              texts = "检测完成";
            } else if (params.row.status == 4) {
              texts = "检测完成";
            } else if (params.row.status == 5) {
              texts = "付款完成";
            } else if (params.row.status == 6) {
              texts = "已完成";
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
          editable: true,
        },
        // { title: "付款状态", key: "pay_status",
        // render: (h, params) => {
        //     let texts = "";
        //     if (params.row.pay_status == 0) {
        //       texts = '未付款';
        //     } else if (params.row.pay_status == 1) {
        //       texts = '已付款';
        //     }
        //     return h(
        //       "div",
        //       {
        //         props: {},
        //       },
        //       texts
        //     );
        //  }, width: 100, editable: true },
        // { title: "付款方式", key: "pay_type",
        // render: (h, params) => {
        //     let texts = "";
        //     if (params.row.pay_type == 0) {
        //       texts = '线下';
        //     } else if (params.row.pay_type == 1) {
        //       texts = '线上';
        //     }
        //     return h(
        //       "div",
        //       {
        //         props: {},
        //       },
        //       texts
        //     );
        //  },
        // width: 100, editable: true },
        // {
        //   title: "入库时间",
        //   key: "into_stock_complete_time",
        //   width: 150,
        //   editable: true,
        // },
        // { title: "开始检测时间", key: "start_check_time", width: 150, editable: true },
        // { title: "检测完成时间", key: "check_complete_time", width: 150, editable: true },
        // {
        //   title: "付款时间",
        //   key: "into_stock_time",
        //   width: 150,
        //   editable: true,
        // },
        {
          title: "Handle",
          key: "handle",
          width: 150,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.viewPiece(params);
                    },
                  },
                },
                "布匹信息"
              ),
              h(
                "Dropdown",
                {
                  props: {
                    transfer: true,
                  },
                },
                [
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                    },
                    "更多"
                  ),
                  h(
                    "DropdownMenu",
                    {
                      slot: "list",
                    },
                    [
                      // h(
                      //   "DropdownItem",
                      //   {
                      //     nativeOn: {
                      //       click: (name) => {
                      //         this.switchPayStatus(params);
                      //       },
                      //     },
                      //   },
                      //   "修改付款状态"
                      // ),
                      // h(
                      //   "DropdownItem",
                      //   {
                      //     nativeOn: {
                      //       click: (name) => {
                      //         this.switchPayType(params);
                      //       },
                      //     },
                      //   },
                      //   "修改付款类型"
                      // ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.downloadLink(params);
                            },
                          },
                        },
                        "下载布匹二维码"
                      ),
                      // h(
                      //   'DropdownItem',
                      //   {
                      //     nativeOn: {
                      //       click: (name) => {
                      //         this.downloadReport(params)
                      //       }
                      //     }
                      //   },
                      //   '下载整缸验布报告'
                      // ),
                      // h(
                      //   'DropdownItem',
                      //   {
                      //     nativeOn: {
                      //       click: (name) => {
                      //         this.downloadShipment(params)
                      //       }
                      //     }
                      //   },
                      //   '下载整缸出货单'
                      // ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.showEditModal(params);
                            },
                          },
                        },
                        "编辑"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.handleDelete(params);
                            },
                          },
                        },
                        "删除"
                      ),
                    ]
                  ),
                ]
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    backHistory() {
      this.$router.go(-1);
    },
    changeId(selection) {
      this.pieceCount = 0;
      this.selectId = [];
      for (let i = 0; i < selection.length; i++) {
        this.pieceCount += selection[i].piece_count
        this.selectId[i] = selection[i].id;
      }
    },
    getOrderDetail() {
      getOrderInfo(this.orderId).then((res) => {
        if (res.data.code == 200) {
          this.orderInfo = res.data.data;
        }
      });
    },
    showAddModal() {
      var data = {};
      getOrderInfo(this.orderId).then((res) => {
        if (res.data.code == 200) {
          data = { id: this.orderId, no: res.data.data.order_no };
          this.$refs.addChild.setOrderData(data);
          this.$refs.addChild.setIsEdit(false);
          this.addModal = true;
          this.resetFlag = !this.resetFlag;
        }
      });
    },
    showEditModal(params) {
      var data = {};
      getOrderInfo(this.orderId).then((res) => {
        if (res.data.code == 200) {
          data = { id: this.orderId, no: res.data.data.order_no };
          this.$refs.editChild.setOrderData(data);
          getBatchInfo(params.row.id).then((res) => {
            if (res.data.code == 200) {
              this.$refs.editChild.setIsEdit(true);
              this.$refs.editChild.setEditData(res.data.data);
              this.editModal = true;
            }
          });
        }
      });
    },
    addSumit(formValidate) {
      addBatch(formValidate)
        .then((res) => {
          // res
          // data {code data msg}
          // status
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.handleSearch();
            this.addModal = false;
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      editBatch(formValidate)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    changeBatchMoney(params, money) {
      let id = params.row.id;
      let data = new FormData();
      data.append("money", money);
      editBatchMoney(id, data).then((res) => {
        if (res.data.code == 200) {
          this.handleSearch();
          this.$Message.success("成功!");
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    downloadLink(params) {
      downloadQr(params.row.id).then((res) => {
        if (res.data.code == 200) {
          window.open(res.data.data);
        }
      });
    },
    viewPiece(params) {
      this.$router.push({ name: "piece", query: { id: params.row.id } });
    },
    switchPayStatus(params) {
      this.batchId = params.row.id;
      if (params.row.status != 4 && params.row.status != 5) {
        this.payMsg = "该染缸还未检测完成，无法修改状态";
        this.hiddenPaySwitch = true;
      } else if (params.row.pay_status == 0) {
        this.payStatus = false;
        this.payLabel = "未付款";
      } else if (params.row.pay_status == 1) {
        this.payStatus = true;
        this.payLabel = "已付款";
      }
      this.payModal = true;
    },
    changePayStatus(status) {
      let data = new FormData();
      data.append("id", this.batchId);
      if (status) {
        data.append("status", 1);
      } else {
        data.append("status", 0);
      }
      editPayStatus(data, this.batchId).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success("成功!");
          if (data.get("status") == 1) {
            this.payLabel = "已付款";
          } else {
            this.payLabel = "未付款";
          }
          this.handleSearch();
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    switchPayType(params) {
      this.batchId = params.row.id;
      if (params.row.pay_type == 1) {
        this.payType = true;
        this.payTypeLabel = "线上";
      } else if (params.row.pay_type == 0) {
        this.payType = false;
        this.payTypeLabel = "线下";
      }
      this.payTypeModal = true;
    },
    changePayType(status) {
      var data = new FormData();
      data.append("id", this.batchId);
      if (status) {
        data.append("type", 1);
      } else {
        data.append("type", 0);
      }
      editPayType(data, this.batchId).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success("成功!");
          if (data.get("type") == 1) {
            this.payTypeLabel = "线上";
          } else {
            this.payTypeLabel = "线下";
          }
          this.handleSearch();
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    downloadReport() {
      if (this.selectId.length == 0) {
        this.$Message.warning("请选择布匹");
        return;
      }

      downloadBatchReport(this.selectId).then((res) => {
        if (res.data.code == 200) {
          var time = this.pieceCount * 50
          window.setTimeout(function () {
            window.open("https://bu.sinano-ai.com/" + res.data.data);
          }, time);
        }
      });
    },
    downloadShipment(type) {
      if (this.selectId.length == 0) {
        this.$Message.warning("请选择布匹");
        return;
      }
      downloadBatchShipment(this.selectId, type).then((res) => {
        if (res.data.code == 200) {
          window.setTimeout(function () {
            if (process.env.NODE_ENV === "production") {
              window.open("https://bu.sinano-ai.com/" + res.data.data);
            } else {
              window.open(
                "https://bu.sinano-ai.com/api/static/" + res.data.data
              );
            }
          }, 2000);
        }
      });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      getBatchList(
        this.page,
        this.pageSize,
        this.searchValue,
        this.orderId,
        this.startTime,
        this.endTime,
        this.status
      ).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否确认删除？</p>",
        onOk: () => {
          delBatch(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.tableData.splice(params.index, 1);
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info("已取消");
        },
      });
      // params
      // row
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.orderId = this.$route.query.id;
    if (this.orderId == undefined) {
      this.orderId = 0;
    }

    this.getOrderDetail();
    this.handleSearch();
  },
};
</script>
